export enum PROMOTION_ERROR_CODE {
  EXPIRED = 'K-080332',
  NOT_VALID = 'K-080104',
  TOO_MANY_ATTEMPTS = 'K-000071',
}
